export const DEFAULT_CACHE_CONFIG = {
  TTLInMinutes: {
    Catalog: 5,
    Side: 60
  }
};
